import { apiQuery_paymentChannel } from '@/resource'

export default {
  data() {
    return {
      africaZotapaySetup: {
        6459: {
          header: 'deposit.uganda.header',
          logo: 'bankUganda',
          dataTestId: 'ugandaZotapay',
        }, // Uganda
        4917: {
          header: 'deposit.rwanda.header',
          logo: 'bankRwanda',
          dataTestId: 'rwandaZotapay',
        }, // Rwanda
        // 6996: {
        //   header: 'deposit.zambia.header',
        //   logo: 'bankZambia',
        //   dataTestId: 'zambiaZotapay',
        // }, // Zambia
        // 7031: { header: 'deposit.congo.header', logo: 'bankCongo', dataTestId: 'congoZotapay' }, // Congo
        4688: {
          header: 'deposit.cameroon.header',
          logo: 'bankCameroon',
          dataTestId: 'cameroonZotapay',
        }, // Cameroon
        // 3865: {
        //   header: 'deposit.burundi.header',
        //   logo: 'bankBurundi',
        //   dataTestId: 'burundiZotapay',
        // }, // Burundi
        4759: { header: 'deposit.kenya.header', logo: 'bankKenya', dataTestId: 'kenyaZotapay' }, // Kenya
        4611: { header: 'deposit.ghana.header', logo: 'bankGhana', dataTestId: 'ghanaZotapay' }, // Ghana
        7089: {
          header: 'deposit.tanzania.header',
          logo: 'bankTanzania',
          dataTestId: 'tanzaniaZotapay',
        }, // Tanzania
      },
      perfectMoneyCountriesList: [
        5176, // United States
        7036, // North Korea
      ],
      equalsIBTCountriesList: [
        3290, // Algeria
        3490, // Angola
        7047, // Antigua and Barbuda
        3346, // Argentina
        6729, // Armenia
        3399, // Acerbaijian
        3588, // Bahamas
        7028, // Bangladesh
        3673, // Bermuda
        3781, // Bolivia
        3808, // Botswana
        3636, // Brazil
        6458, // Brunei
        4540, // Djibouti
        4070, // Ecuador
        4611, // Ghana
        4254, // Guyana
        4514, // Honduras
        3714, // Iceland
        4266, // Kazakhstan
        4759, // Kenya
        4535, // Kiribati
        4735, // Kuwait
        4546, // Krgyzstan
        5160, // Mauritius
        5557, // Micronesia
        5527, // Mongolia
        5681, // Namibia
        5751, // Nepal
        3389, // Oman
        3600, // Paraguay
        6050, // Sao Tome and Principe
        5987, // Serbia
        6057, // Sri Lanka
        6146, // Tajikistan
        7089, // Tanzania
        6278, // Tunisia
        6385, // Turkmenistan
        6304, // Tuvalu
        7083, // Saint Maarten / Saint Martin
        3512, // Australia
        6094, // Slovenia
        3382, // United Arab Emirates
        3809, // Belize
        7061, // Gibraltar
        7065, // Isle Of Man
        5156, // Marshall Islands
        7039, // Saint Kitts and Nevis
        6056, // Saint Vincent and the Grenadines
        6024, // Seychelles
        6431, // Virgin Islands
        4700, // Qatar
      ],
      localDepositorCountriesList: [
        5015, //malaysia
      ],
      mysCountryCode: 5015,
      idnCountryCode: 6877, // indonesia
      inCountryCode: 6845, // india
      ngaCountryCode: 5796, //Nigeria
      thaCountryCode: 6163,
      vnmCountryCode: 6991,
      phpCountryCode: 4131, // Philippines
      canCountryCode: 4575, // Canada
      ausCountryCode: 3512, // Australia
      krCountryCode: 7041,
      chCountryCode: 1, // china
      brlCountryCode: 3636, // Brazil
      jpyCountryCode: 5860, // Japan
      zarCountryCode: 5696, // South Africa
      qatCountryCode: 4700, // Qatar
      nlCountryCode: 4482, //	Netherlands
    }
  },
  methods: {
    query_paymentChannel() {
      apiQuery_paymentChannel()
        .then(resp => {
          if (resp.data.code == 0) {
            if (resp.data.data == 1) this.$router.push({ path: `/deposit/thailandZotaPay/${resp.data.data}` })
          }
        })
        .catch(err => {
          this.$message({
            message: 'Fetch payment channel failed.',
            type: 'error',
          })
        })
    },
    notRestricted(type, channel = 1) {
      return this.restrictedDeposit === 0 ? true : this.checkRestricted(type, channel)
    },
    checkRestricted(type, channel) {
      let restricted = false

      this.restrictedDeposit.forEach(function(x, y) {
        if (x.paymentType === type && x.paymentChannel === channel) {
          restricted = true
        }
      })
      if (
        this.$config.restrictCreditCardCountry({
          reg: this.$store.state.common.regulator,
          countryCode: this.countryCode,
        })
      ) {
        restricted = true
      }
      return !restricted
    },
    zotaClick() {
      if (this.countryCode == this.phpCountryCode) {
        this.$router.push({ name: 'philipinessPayment' })
      } else if (this.countryCode == this.thaCountryCode) {
        this.query_paymentChannel()
      }
    },
    PaystackClick() {
      this.$router.push({ name: 'paystack' })
    },
    thailandXpayClick() {
      this.$router.push({ name: 'thailandXpay' })
    },
    vietnamXpayClick() {
      this.$router.push({ name: 'vietnamXpay' })
    },
    vietnamZotapayClick() {
      this.$router.push({ name: 'vietnamZotapay' })
    },
    malaysiaPaytrustClick() {
      this.$router.push({ name: 'malaysiaPaytrust' })
    },
    malaysiaZotapayClick() {
      this.$router.push({ name: 'malaysiaZotapay' })
    },
    malaysiaXpayClick() {
      this.$router.push({ name: 'malaysiaXpay' })
    },
    indonesiaBankwireClick() {
      this.$router.push({ name: 'indonesiaBankwire' })
    },
    indonesiaXpayClick() {
      this.$router.push({ name: 'indonesiaXpay' })
    },
    indonesiaZotapayClick() {
      this.$router.push({ name: 'indonesiaZotapay' })
    },
    apgClick() {
      this.$router.push({ name: 'apgDeposit' })
    },
    sdPayClick() {
      this.$router.push({ path: `/deposit/sdPay` })
    },
    solidpaymentClick() {
      this.$router.push({ path: `/deposit/solidpayment` })
    },
    virtualPayClick() {
      this.$router.push({ name: 'virtualPayDeposit' })
    },
    worldcardClick() {
      this.$router.push({ name: 'worldcardDeposit' })
    },
    // maxisPayClick() {
    //   this.$router.push({ name: 'maxisPayDeposit' })
    // },
    bitwalletClick() {
      this.$router.push({ name: 'bitwalletDeposit' })
    },
    dragonPhoenixClick() {
      this.$router.push({ name: 'dragonPhoenixDeposit' })
    },
    ebuyClick() {
      this.$router.push({ name: 'ebuyDeposit' })
    },
    bridgePaymentClick() {
      this.$router.push({ name: 'bridgePaymentDeposit' })
    },
    internationalClick(type) {
      if (type == 1) {
        this.$router.push({ name: 'internationalSwift' })
      }
      if (type == 2) {
        this.$router.push({ name: 'internationalEqualsMoney' })
      }
    },
    australiaClick() {
      this.$router.push({ name: 'bankWireAustralia' })
    },
    bpayClick() {
      this.$router.push({ name: 'bPayDeposit' })
    },
    poliClick() {
      this.$router.push({ name: 'poliPay' })
    },
    skrillClick() {
      this.$router.push({ name: 'skrillPay' })
    },
    sticPayClick() {
      this.$router.push({ name: 'sticPay' })
    },
    netellerClick() {
      this.$router.push({ name: 'neteller' })
    },
    canadaLocalBankClick() {
      this.$router.push({ name: 'canadaLocalBank' })
    },
    brokerClick() {
      this.$router.push({ name: 'brokerToBrokerTransfer' })
    },
    unionClick() {
      this.$router.push({ name: 'unionPay' })
    },
    chinaUnionClick() {
      this.$router.push({ name: 'unionPayChina' })
    },
    fasapayClick() {
      this.$router.push({ name: 'fasaPay' })
    },
    mobileClick() {
      this.$router.push({ name: 'mobilePay' })
    },
    paypalClick() {
      this.$router.push({ name: 'paypal' })
    },
    trustlyClick() {
      this.$router.push({ name: 'trustly' })
    },
    bitcoinClick() {
      this.$router.push({ name: 'bitcoin' })
    },
    usdtClick(channel) {
      this.$router.push({ path: `/deposit/usdt/${channel}` })
    },
    bitcoinCPSClick() {
      this.$router.push({ name: 'bitcoinCPS' })
    },
    omniCPSClick() {
      this.$router.push({ name: 'omniCPS' })
    },
    usdt_cpsClick() {
      this.$router.push({ name: 'usdt_cps' })
    },
    trc20_cpsClick() {
      this.$router.push({ name: 'trc20_cps' })
    },
    // astropayClick() {
    //   this.$router.push({ name: 'astropayDeposit' })
    // },
    indiaZotapayClick() {
      this.$router.push({ name: 'indiaZotapay' })
    },
    southAfricaClick() {
      this.$router.push({ name: 'southAfricaPayment' })
    },
    africaClick() {
      this.$router.push({ name: 'africaZotapay' })
    },
    perfectMoneyClick() {
      this.$router.push({ name: 'perfectMoney' })
    },
    indiaBankTransferClick() {
      this.$router.push({ name: 'indiaBankTransfer' })
    },
    nigeriaBankTransferClick() {
      this.$router.push({ name: 'nigeriaBankTransfer' })
    },
    localDepositorClick() {
      this.$router.push({ name: 'localdepositor' })
    },
    iDealClick() {
      this.$router.push({ name: 'iDeal' })
    },
  },
  computed: {
    countryCode() {
      return parseInt(this.$store.state.common.countryCode)
    },
    restrictedAfricaZotapay() {
      return !this.africaZotapaySetup.hasOwnProperty(this.countryCode)
    },
    restrictedDeposit() {
      return this.$store.state.payment.restrictedDeposit
    },
    excludePerfectMoneyCountries() {
      return !this.perfectMoneyCountriesList.includes(this.countryCode)
    },
    excludeEqualsIBTCountries() {
      return this.equalsIBTCountriesList.includes(this.countryCode)
    },
    localDepositorCountries() {
      return this.localDepositorCountriesList.includes(this.countryCode)
    },
  },
}
